import { Box, useTheme } from "@mui/material";
import TherapistLogo from "../../media/TherapistLogo";
import PatientLogo from "../../media/PatientLogo";
import CenterLogo from "../../media/CenterLogo";
import { Role } from "../login/PremiumUser";
import UserNoLicenseLogo from "../../media/UserNoLicenseLogo";

interface UserLogoProps {
	role: Role,
	width: any
}

function UserLogo(props: UserLogoProps) {

	const theme = useTheme();

	const role = props.role;

	return (
		<Box maxWidth={props.width} display="flex" justifyContent="center" alignItems="center">
			{role === Role.Therapist &&
				<TherapistLogo width="100%"
					primary={theme.palette.primary.main}
					secondary={theme.palette.secondary.main}
					stroke={theme.palette.text.primary} />
			}
			{role === Role.Patient &&
				<PatientLogo width="100%"
					primary={theme.palette.primary.main}
					secondary={theme.palette.secondary.main}
					stroke={theme.palette.text.primary} />
			}
			{role === Role.Centre &&
				<CenterLogo width="100%"
					primary={theme.palette.primary.main}
					secondary={theme.palette.secondary.main}
					stroke={theme.palette.text.primary} />
			}
			{role === Role.None &&
				<UserNoLicenseLogo width="100%"
					primary={theme.palette.primary.main}
					secondary={theme.palette.secondary.main}
					stroke={theme.palette.text.primary} />
			}
		</Box>
	);
}

export default UserLogo;